import ThemeOptions from './ThemeOptions'
import AuthOptions from './AuthOptions'

export default {
  ThemeOptions,
  AuthOptions
}
